import { api } from "..";

interface BanSubDealerPayload {
  subDealerId: number;
  reason?: string | null;
  expiresAt?: string | null;
}

interface UnbanSubDealerPayload {
  subDealerId: number;
}

export async function banSubDealer(
  payload: BanSubDealerPayload
): Promise<{ success: boolean }> {
  const { subDealerId, ...body } = payload;
  const res = await api.client.put(`/sub-dealers-new/${subDealerId}/ban`, body);
  return res.data;
}

export async function unbanSubDealer(
  payload: UnbanSubDealerPayload
): Promise<{ success: boolean }> {
  const res = await api.client.delete(
    `/sub-dealers-new/${payload.subDealerId}/ban`
  );
  return res.data;
}
